export default function (exceptions: Array<number>): number {
  let random = Math.floor(Math.random() * 90000) + 10000;
  while (exceptions.includes(random)) {
    random = Math.floor(Math.random() * 90000) + 10000;
  }
  return random;
}
